import React, { useEffect} from 'react';
import { useDispatch,useSelector } from "react-redux";

import { fetchOverAllThreatActors as getThreatActorService, fetchThreatActorsByDomain as getThreatActorsByDomainService} from 'services/modules/ecs/data';

import ThreatActorByRegion from './threatactor-region';
import ThreatActorGeography from './ThreatActorGeography';
import {Card} from '@mui/material'


function DashboardPage() {
  // Redux dispatch  
  const dispatch =useDispatch();

  // Redux selectors
  const selectedCompany = useSelector((state) => state.auth.companyData);
  
  // Fetches threat actors by domain and stimulates the graph based on them
  useEffect(()=>{
    if (selectedCompany){
      const fetchThreatActorsData = async () =>{
        const domain = selectedCompany.domain;
        let params = {domain:domain};
        dispatch(getThreatActorsByDomainService({ params }));
        dispatch(getThreatActorService({params}));
      };
      fetchThreatActorsData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[selectedCompany]);


  return (
    <div>
      <div className="row">
        <Card className="col-9 col-xs-12 col-sm-12 col-md-12 col-lg-9 mt-5" style={{border:'2px solid grey',borderRadius:'3vh',margin:'10px'}}>
        <ThreatActorGeography/>
        </Card>
        <div className="col-2 col-xs-12 col-sm-12 col-md-12 col-lg-2 mt-5">
        <ThreatActorByRegion />
        </div>
      </div>
    </div>
  )
};

export default DashboardPage;
